import { withCompInfo } from '@wix/editor-elements-integrations'
import { getScaledFont } from '@wix/thunderbolt-becky-root'
import { getFullId } from '@wix/thunderbolt-commons'
import type { DatePickerCssCarmiData, DatePickerDefinition } from '@wix/thunderbolt-components-native'

export const css = withCompInfo<DatePickerCssCarmiData, DatePickerDefinition>()(
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	['compProps', 'compLayout', 'styleProperties', 'siteFonts', 'isMobileView', 'isOneDocMigrated'],
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	({ compProps, compLayout, styleProperties, siteFonts, isMobileView, isOneDocMigrated }) => {
		const compInfo = { compLayout, compProps, styleProperties, siteFonts, isMobileView }
		return {
			'--fntlbl': getScaledFont(compInfo, 'fntlbl', isOneDocMigrated, compProps.labelMobileFontSize, 16),
			'--fnt': getScaledFont(compInfo, 'fnt', isOneDocMigrated, compProps.inputMobileFontSize, 13),
		}
	}
)

export const props = withCompInfo<any, DatePickerDefinition>()(['compId'], ({ compId }) => {
	return {
		templateId: getFullId(compId),
	}
})
